let UTILS = require("../libs/utils.js");
var v7722;
var v7723;
module.exports = {
  id: "king",
  name: "King of the Hill",
  alias: "king",
  endStats: ["sid", "name", "score", "kills", "deaths", "objective", "reward"],
  objective: true,
  killMlt: 0.15,
  hillMlt: 0.05,
  objScore: 10,
  gameStart: function (p9155) {
    p9155.activeObjective = -1;
    p9155.randObjective(null, true);
  },
  collisionCheck: function (p9156, p9157) {
    for (var vLN01214 = 0; vLN01214 < p9156.map.manager.objectives.length; ++vLN01214) {
      v7722 = p9156.map.manager.objectives[vLN01214];
      if (v7722 && v7722.uid == p9156.activeObjective && p9157.collides(v7722)) {
        p9157.onZone = v7722.uid;
      }
    }
  },
  update: function (game, p9159, p9160) {
    if (game.map.manager.objectives.length && game.waitTimers && game.waitTimers[0].contTime) {
      var v7724 = false;
      game.objectiveTimer -= p9160;
      if (game.objectiveTimer <= 0) {
        game.objectiveTimer = 1500;
        v7724 = true;
      }
      for (var vLN01215 = 0; vLN01215 < game.map.manager.objectives.length; ++vLN01215) {
        v7722 = game.map.manager.objectives[vLN01215];
        if (v7722 && v7722.uid == game.activeObjective) {
          var v7725 = v7722.onZone;
          var vA382 = [];
          for (var vLN01216 = 0; vLN01216 < game.players.list.length; ++vLN01216) {
            v7723 = game.players.list[vLN01216];
            if (v7723.active && v7723.collides(v7722)) {
              vA382.push(vLN01216);
            }
          }
          v7722.onZone = vA382.length;
          if (v7722.onZone == 1 && v7724 && game.players.list[vA382[0]]) {
            game.players.score(game.players.list[vA382[0]], game.mode.objScore, 2);
          }
          if (v7725 != v7722.onZone) {
            game.broadcast("uobj", v7722.uid, v7722.onZone);
          }
        }
      }
    }
  },
  onKill: function (game, p9162, p9163, p9164) {
    if (p9164 && p9164 != p9163) {
      if (p9164.onZone == game.activeObjective) {
        game.players.score(p9164, 50);
        game.incMedal("Defender", p9164);
        p9164.send("am", [25, 50, 0, 1]);
        p9164.killMlt += game.mode.hillMlt;
        game.challenges.update(game, "defm", 1, null, p9164);
      } else if (p9163.onZone == game.activeObjective) {
        game.players.score(p9164, 25);
        game.incMedal("Attacker", p9164);
        p9164.send("am", [25, 25, 0, 1]);
        game.challenges.update(game, "atkm", 1, null, p9164);
      }
    }
  }
};